import type { ReactElement } from 'react';
import { t, type WithI18nLocale } from '@ardoq/i18n';
import { FlexBox } from '@ardoq/layout';
import { ArdoqLoaderComponent, LoaderColor, LoaderSize } from '@ardoq/loader';

type SurveyAdminLoaderProps = WithI18nLocale;

export const SurveyAdminLoader = ({
  i18nLocale,
}: SurveyAdminLoaderProps): ReactElement => {
  const loadingText = t(
    i18nLocale,
    'surveyAdmin:loadingData',
    'Loading data...'
  );
  return (
    <FlexBox width="full" height="full" align="center" justify="center">
      <ArdoqLoaderComponent
        loaderText={loadingText}
        loaderColor={LoaderColor.BRAND}
        size={LoaderSize.MEDIUM}
        ariaLabel={loadingText}
      />
    </FlexBox>
  );
};
